import React, { useCallback, useEffect, useState } from "react";
import { serverDomain } from "../../../config";

const emptyPostbacks = { start: "", registration: "", purchase: "", auto_debit: "" };

const BynaTestOfferPage = () => {
  const [offer, setOffer] = useState(null);
  const [links, setLinks] = useState([]);
  const [logs, setLogs] = useState([]);
  const [postbacks, setPostbacks] = useState(emptyPostbacks);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [createdUrl, setCreatedUrl] = useState("");

  const request = useCallback(async (path, options = {}) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${serverDomain}/api/byna-test/admin/${path}`, {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...options.headers,
      },
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || "Не удалось выполнить запрос");
    return data;
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const [overview, deliveryLogs] = await Promise.all([
        request("overview"),
        request("logs"),
      ]);
      setOffer(overview.offer);
      setLinks(overview.links || []);
      setLogs(deliveryLogs || []);
    } catch (loadError) {
      setError(loadError.message);
    } finally {
      setLoading(false);
    }
  }, [request]);

  useEffect(() => { load(); }, [load]);

  const createOffer = async () => {
    setSaving(true);
    setError("");
    try {
      await request("offer", { method: "POST", body: JSON.stringify({}) });
      await load();
    } catch (saveError) {
      setError(saveError.message);
    } finally {
      setSaving(false);
    }
  };

  const createLink = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError("");
    setCreatedUrl("");
    try {
      const result = await request("links", { method: "POST", body: JSON.stringify({ postbacks }) });
      setCreatedUrl(result.ref_url);
      setPostbacks(emptyPostbacks);
      await load();
    } catch (saveError) {
      setError(saveError.message);
    } finally {
      setSaving(false);
    }
  };

  const copyLink = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (_) {
      setError("Не удалось скопировать ссылку");
    }
  };

  return (
    <div className="fl-adminpage">
      <div className="fl-adminpage__head">
        <div>
          <h2>Byna.Ru · тестовый RevShare</h2>
          <p>Управление тестовым оффером доступно только администраторам.</p>
        </div>
        <button className="fl-btn" type="button" onClick={load} disabled={loading}>Обновить</button>
      </div>

      {error ? <p role="alert">{error}</p> : null}
      {loading ? <div className="loading-container"><div className="loader" /></div> : (
        <>
          {!offer ? (
            <button className="fl-btn" type="button" onClick={createOffer} disabled={saving}>
              Создать тестовый оффер
            </button>
          ) : (
            <>
              <div className="fl-adminpage__meta">Оффер: <b>{offer.name}</b></div>
              <form className="fl-formGrid" onSubmit={createLink}>
                <h3>Новая реферальная ссылка</h3>
                {Object.entries({
                  start: "Start postback",
                  registration: "Registration postback",
                  purchase: "Purchase postback",
                  auto_debit: "Auto-debit postback",
                }).map(([key, label]) => (
                  <label className="fl-labelBlock" key={key}>
                    {label}
                    <input
                      className="fl-input fl-input--wide"
                      type="text"
                      value={postbacks[key]}
                      onChange={(event) => setPostbacks((current) => ({ ...current, [key]: event.target.value }))}
                      placeholder="https://partner.example/postback?clickid={clickid}&payment={payment}"
                    />
                  </label>
                ))}
                <button className="fl-btn" type="submit" disabled={saving}>Сгенерировать ссылку</button>
              </form>

              {createdUrl ? <p>Создана ссылка: <button className="fl-linkbtn" type="button" onClick={() => copyLink(createdUrl)}>{createdUrl}</button></p> : null}

              <h3>Ссылки и конверсии</h3>
              <div className="fl-table-wrap">
                <table className="fl-table">
                  <thead><tr><th>Код</th><th>Ссылка</th><th>Переходы</th><th>Регистрации</th><th>Покупки</th><th>Автосписания</th><th>Комиссия, RUB</th></tr></thead>
                  <tbody>
                    {links.map((link) => (
                      <tr key={link.link_code}>
                        <td>{link.link_code}</td>
                        <td><button className="fl-linkbtn" type="button" onClick={() => copyLink(link.ref_url)}>{link.ref_url}</button></td>
                        <td>{link.starts}</td><td>{link.registrations}</td><td>{link.purchases}</td><td>{link.auto_debits}</td><td>{Number(link.commission).toFixed(2)}</td>
                      </tr>
                    ))}
                    {!links.length ? <tr><td colSpan="7">Пока нет ссылок</td></tr> : null}
                  </tbody>
                </table>
              </div>

              <h3>Доставка postback-ов</h3>
              <div className="fl-table-wrap">
                <table className="fl-table">
                  <thead><tr><th>Дата</th><th>Код</th><th>Событие</th><th>Статус</th><th>Попытки</th><th>HTTP</th><th>URL (секреты скрыты)</th></tr></thead>
                  <tbody>
                    {logs.map((log) => (
                      <tr key={`${log.created_at}-${log.link_code}-${log.event_type}`}>
                        <td>{new Date(log.created_at).toLocaleString()}</td><td>{log.link_code}</td><td>{log.event_type}</td><td>{log.status}</td><td>{log.attempts}</td><td>{log.last_response_code || "—"}</td><td>{log.url_redacted}</td>
                      </tr>
                    ))}
                    {!logs.length ? <tr><td colSpan="7">Отправок пока нет</td></tr> : null}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default BynaTestOfferPage;
